module.exports = __webpack_public_path__ + "img/bg.31027eef.png";